import {transitions} from "@cdx/ds/css/decoration.css";
import dsStyles from "@cdx/ds/css/index.css";
import {colorThemeVars} from "@cdx/ds/css/themes/themes.css";
import {style} from "@vanilla-extract/css";

export const arrowStyles = {
  base: style([
    dsStyles.position.absolute,
    dsStyles.width[0],
    dsStyles.height[0],
    {
      borderColor: "transparent",
      borderStyle: "solid",
    },
    transitions.colors,
  ]),
  bySize: {
    xs: style({borderWidth: 5}),
    sm: style({borderWidth: 7}),
    md: style({borderWidth: 10}),
  },
  byDirAndSize: {
    vertical: {
      xs: style({marginTop: -4}),
      sm: style({marginTop: -7}),
      md: style({marginTop: -10}),
    },
    horizontal: {
      xs: style({marginLeft: -5}),
      sm: style({marginLeft: -7}),
      md: style({marginLeft: -10}),
    },
  },
  byPosition: {
    top: style({
      borderTopWidth: 0,
      bottom: "100%",
      left: "50%",
      borderBottomColor: colorThemeVars.bg,
    }),
    bottom: style({
      borderBottomWidth: 0,
      top: "100%",
      left: "50%",
      borderTopColor: colorThemeVars.bg,
    }),
    left: style({
      borderLeftWidth: 0,
      top: "50%",
      right: "100%",
      borderRightColor: colorThemeVars.bg,
    }),
    right: style({
      borderRightWidth: 0,
      top: "50%",
      left: "100%",
      borderLeftColor: colorThemeVars.bg,
    }),
  },
};
